<template>
  <BlockWrapper class="leave-request">
    <bim-text class="text-center leave-request__title" type=h5 bold>Есть клиент на примете?</bim-text>
    <bim-text
      class="text-center leave-request__desc mx-auto"
      type=main
      v-if="manufacturer_count"
    >
      Успешно довели до сделки более {{ manufacturer_count }} производителей, у нас это хорошо получается.
    </bim-text>
    <ButtonLeaveApplication class="text-center" label="Оставить заявку на участие в программе" />
    <bim-text class="text-center leave-request__info mt-12" type=medium>Предложение носит информационный характер и не является публичной офертой</bim-text>
  </BlockWrapper>
</template>

<script>
import ButtonLeaveApplication from './ButtonLeaveApplication'
import { mapState } from 'vuex'
export default {
  name: "block",
  components: {
    ButtonLeaveApplication,
  },
  computed: {
    ...mapState('counters', [
      'manufacturer_count'
    ])
  }
}
</script>

<style lang="scss" scoped>
.leave-request {
  padding: 100px 0;
  background-color: #f7f7f7;

  .leave-request__desc {
    margin: 32px 0 54px;
    max-width: 600px;
    line-height: 1.5;
    letter-spacing: 0.2px;
  }

  .leave-request__info {
    opacity: .7;
  }
}
</style>
